import Vue from 'vue'
import Vuex from 'vuex'
import {
  getFeedDetail,
  getComment,
  getTopicFeedList,
  reportSend,
} from '@/api'
import getEnv from '@/utils/env'
import {
  InitData,
  ParamObject,
} from '@/model'
import { formatDateTime, formatRaceDateTime } from '@/utils/date'
import { getCookie } from '../utils/util'

Vue.use(Vuex)

const initData: InitData = {
  loading: true,
}

export default new Vuex.Store({
  state: {
    initData,
    feedDetail: {},
    comment: {},
    topicFeedList: [], // 话题帖子列表
  },
  getters: {
    initData (state) {
      return state.initData
    },
    feedDetail (state) {
      return state.feedDetail;
    },
    comment (state) {
      return state.comment;
    },
    topicFeedList (state) {
      return state.topicFeedList;
    },
  },
  mutations: {
    updateInitData (state, data: {key: string, value: any}) {
      state.initData[data.key] = data.value
    },
    updateFeedDetail (state, data) {
      state.feedDetail = data;
    },
    updateComment (state, data) {
      state.comment = data;
    },
    updateTopicFeedList (state, data) {
      state.topicFeedList = data;
    },
  },
  actions: {
    async getFeedDetail ({commit}, params: object) {
      // console.log("===> begin getComment api", params)
      let res = await getFeedDetail(params);
      // for test
      // res = {"error":{"errmsg":"invalid field OpenId: value '' must not be an empty string","result":3}};
      // if (res.error) {
      //   throw res
      // }
      commit('updateFeedDetail', res);
      return res;
    },
    async getComment ({commit}, params: object) {
      // console.log("===> begin getComment api")
      const res = await getComment(params);
      if (res.error) {
        throw res
      }
      const newData: any = [];
      res.data.forEach((item: any, index: number) => {
        if (item.replyData) {
          const newReply: any = [];
          item.replyData.replies.forEach((sitem: any, sindex: number) => {
            if (sindex < 3) {
              sitem.replyDate = formatDateTime(new Date(sitem.lastTime*1000));
              newReply.push(sitem);
            }
          });
          item.replyData.replies = newReply;
        }
        if (index < 3) {
          newData.push(item);
        }

      });
      res.data = newData;
      // console.log(res)
      commit('updateComment', res);
    },
    async getTopicFeedList ({commit}, params: object) {
      const res = await getTopicFeedList(params);
      // {"error":{"errmsg":"invalid field OpenId: value '' must not be an emptystring","result":3}}

      if (res.error) {
        throw res
      }
      commit('updateTopicFeedList', res);
    },
    async reportSend ({commit}, params: any) {
      const data = {
        scene: 24,
        common: {
          lang: getCookie('language') || 'en_US',
          ua: navigator.userAgent,
          ...params.common
        },
        param: {
          url: window.location.href,
          ...params.param
        }
      };
      const res = await reportSend(data);
      if (res.error) {
        throw res
      }
    },
  },
  modules: {},
  strict: getEnv() !== 'production'
})
